import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from "@/views/HomePage";
import About from "@/views/About";
import ProductsName from "@/views/ProductsName";
import ProductsDetail from "@/views/ProductsDetail"
import Login from "@/views/Login";
import Profile from "@/views/Profile";
import Cart from "@/views/Cart";
import OrderBill from "@/views/OrderBill";
import Error404 from "@/views/Error404"


Vue.use(VueRouter)

const routes = [
  {
    path : "/",
    name: "HomePage",
    component : HomePage,
  },
  {
    path : "/about",
    name: "About",
    component : About,
  },
  {
    path : "/product",
    name : "Products",
    component : ProductsName,
  },
  {
    path : "/product/:id",
    name : "ProductsDetail",
    component : ProductsDetail,
  },
  {
    path : "/login",
    name : "Login",
    component : Login
  },
  {
    path : "/cart",
    name : "Cart",
    component : Cart,
  },
  {
    path :"/profile",
    name : "Profile",
    component : Profile,
    // beforeEnter: (to, from,next) => {
    //   let auth = localStorage.getItem("auth")
    //   if(auth){
    //     next()
    //   }else{
    //     next("/login")
    //   }

    // },
  },
  {
    path : "/order",
    name : "OrderBill",
    component : OrderBill
  },
  {
    path : "*",
    name : "Error404",
    component :Error404,
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from,next) => {
  if(to.path === "/profile" || to.path === "/product"){
    let auth = localStorage.getItem("auth")
      if(auth){
        next()
      }else{
        next("/login")
      }
  }else{
    next()
  }
})


export default router
